import React from "react";
import { getFormattedNumber, getTotal } from "../utils/textUtils";
import { Link } from "react-router-dom";

const SalesByInvoice = ({ resPacket }) => {
  let totalWithoutTax = 0;
  return resPacket?.length > 0 ? (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>INVOICE DATE</td>
            <td>CUSTOMER NAME</td>
            <td>CUSTOMER CATEGORY</td>
            <td>INVOICE NO.</td>
            <td className="text-center">TOTAL AMOUNT</td>
            <td className="text-center">TOTAL WITHOUT TAX</td>
            <td className="text-center">TAX AMOUNT</td>
            <td className="text-center">VEHICLE NO.</td>
            <td className="text-right">SHIPPING CHARGES</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket &&
            resPacket.map((a, i) => {
              totalWithoutTax += Number(
                a.totalAmount - a.totalTax - a.shippingCharges
              );
              return (
                <tr key={i}>
                  <td>{i+1}</td>
                  <td>{a.invoiceDate}</td>
                  <td>{a.customerTitle}</td>
                  <td>{a.customerCategory}</td>
                  <td>
                    <Link to={`/invoices/${a.recordId}`} target="_blank">
                      {a.invoiceNo}
                    </Link>
                  </td>

                  <td className="text-center">
                    ₹ {getFormattedNumber(a.totalAmount)}
                  </td>
                  <td className="text-center">
                    ₹
                    {getFormattedNumber(
                      a.totalAmount - a.totalTax - a.shippingCharges
                    )}
                  </td>
                  <td className="text-center">
                    ₹ {getFormattedNumber(a.totalTax)}
                  </td>
                  <td style={{justifyContent:"center"}}>
                    {a?.motorVehicleNo}
                  </td>
                  <td className="text-right">
                    {getFormattedNumber(a.shippingCharges)}
                  </td>
                </tr>
              );
            })}
          <tr>
            <td>TOTAL:</td>
            <td></td>
            <td></td>
            <td className="text-right">
              ₹ {getFormattedNumber(getTotal(resPacket, "totalAmount"))}
            </td>
            <td className="text-right">
              ₹ {getFormattedNumber(totalWithoutTax)}
            </td>
            <td className="text-right">
              ₹ {getFormattedNumber(getTotal(resPacket, "totalTax"))}
            </td>
            <td className="text-right">
              ₹ {getFormattedNumber(getTotal(resPacket, "shippingCharges"))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <>no Record found</>
  );
};

export default SalesByInvoice;
